export const capitalize = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const onlyAlphanumeric = (string: string) => string.replace(/\W/g, "");

export const onlyNumbers = (string: string) => string.replace(/\D/g, "");

export const insertAt = (string: string | any[], stringToInsert: string, index: number) =>
  [string.slice(0, index - 1), string.slice(index - 1)].join(stringToInsert);

export const textWithBreakLine = (text: string) => text.replace(/(?:\r\n|\r|\n)/g, "<br/>");

export const capitalizeFullName = (string = "") => {
  const prepositions = ["dos", "de", "da", "do", "di"];
  const str = string.toLowerCase().trim().split(" ");
  const capitalizeString = str.map(element => {
    const word = element.split("");
    if (!prepositions.includes(element)) {
      word[0] = (word[0] || "").toUpperCase();
    }
    return word.join("");
  });
  return capitalizeString.join(" ");
};

export const getInitials = (string = "") => {
  const names = string.split(" ");
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) initials += names[names.length - 1].substring(0, 1).toUpperCase();
  else initials += names[0].substring(1, 2).toUpperCase();

  return initials;
};

export const assureJsonParse = (string: string) => {
  try {
    const parsed = JSON.parse(string);
    return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
  } catch (e) {
    return null;
  }
};

const commonSeparators = [" ", "(", ")", "'", "-"];

export const sanitizeString = (string: string, separators = commonSeparators) =>
  string
    ?.split("")
    .filter((char: string) => !separators.includes(char))
    .join("")
    .toLowerCase();

export const replaceCharAt = (str: string, char: any, index: any) =>
  str.split("").reduce((acc: any, cur: any, i: any) => (i === index ? acc + char : acc + cur));

export const maskString = (str: string, mask: string | ArrayLike<string>) => {
  if (!str) return "";
  const digitsOnly = str.replace(/\D/g, "");

  let maskedString = "";
  let digitIndex = 0;

  Array.from(mask).forEach((_char, i) => {
    if (mask[i] === "#") {
      if (digitIndex < digitsOnly.length) {
        maskedString += digitsOnly[digitIndex];
        digitIndex += 1;
      }
    } else {
      maskedString += mask[i];
    }
  });

  return maskedString;
};

export const findStringFirstOcurrenceIndexInArray = (string: any, array: string | any[]) => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i] === string) {
      return i;
    }
  }
  return -1;
};
